module.exports = __webpack_public_path__ + "img/1473060232.5a88e77b.jpg";